// FileLibraryContext.tsx
import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { sendAxiosPost } from "../util/ServerUtil";
import { useAppContext } from "./AppContext";

// -------------------------
// Data Interfaces
// -------------------------

export interface LinkData {
    accessTier: number;
    title: string;
    url: string;
}

export interface EpisodeData {
    id: string;
    name: string;
    accessTier: number; // 1 = dreaming, 2 = deeper
    type: string;
    episode: number;
    flavorText: string;
    description: string;
    streamLinks: LinkData[];
    downloadLinks: LinkData[];

    // add string index to return flat1080p, flat4k, vr1080p, or vr4k
    [key: string]: string | number | LinkData[];
}

export interface SeriesData {
    id: string;
    name: string;
    seriesTier: number;
    //order: number;
    type: string;
    cover: string;
    flavorText: string;
    description: string;
    tags: string[];     // list of tags
    cw: string[];       // list of content warning tags
    episodes: EpisodeData[];
    seriesLinks: LinkData[]; // list of links for the series download

    // add string index to return flat1080p, flat4k, vr1080p, or vr4k
    [key: string]: string | string[] | number | EpisodeData[] | LinkData[];
}

export interface FileLibrary {
    series: SeriesData[];
}

export const buildFileLibrary = (seriesJson: any): FileLibrary | null => {
    if (!seriesJson || seriesJson.length === 0) {
        return null;
    }

    console.log(seriesJson)

    // sort seriesJson by seriesData.order (descending, lowest number last)
    const fileLibrary: SeriesData[] = seriesJson.sort((a: any, b: any) => b.order - a.order).map((seriesObj: any) => {
        
        let episodes: EpisodeData[] = [];

        // Check for no episodes
        if (!seriesObj.episodes || seriesObj.episodes.length === 0 || seriesObj.episodes === "none") {
            // do nothing, just return an empty array for episodes
        } else {
            episodes = seriesObj.episodes.map((ep: any) => ({
                id: ep.id,
                name: ep.name,
                accessTier: ep.accessTier || 1, 
                type: ep.type || "video",
                episode: ep.episode,
                flavorText: ep.flavorText,
                description: ep.description,
                streamLinks: ep.streamLinks,
                downloadLinks: ep.downloadLinks,
            }));
        }

        return {
            id: seriesObj.id,
            name: seriesObj.name,
            order: seriesObj.order,
            seriesTier: seriesObj.seriesTier || 1,
            cover: seriesObj.cover,
            type: seriesObj.type,
            flavorText: seriesObj.flavorText,
            description: seriesObj.description,
            intensity: seriesObj.intensity,
            tags: seriesObj.tags,
            cw: seriesObj.cw,
            episodes,
            seriesLinks: seriesObj.seriesLinks
        };
    });

    return { series: fileLibrary };
}